const REDIRECTS: Record<string, string> = {
  'https://sunpoint.de': 'https://www.sunpoint.de',
  'https://wellmaxx-bodyforming.com': 'https://www.wellmaxx-bodyforming.com',
  'http://sunpoint.de': 'https://www.sunpoint.de',
  'http://wellmaxx-bodyforming.com': 'https://www.wellmaxx-bodyforming.com',
}

/** Returns redirect target URL if current href matches a rule, else null. Exported for tests. */
export function getRedirectTarget(currentHref: string): string | null {
  for (const from in REDIRECTS) {
    if (currentHref.indexOf(from) === 0) {
      return REDIRECTS[from] + currentHref.substr(from.length)
    }
  }
  return null
}

interface useRedirectStandardReturnType {}

const useRedirectToStandard = (): useRedirectStandardReturnType => {
  if (typeof document !== 'undefined') {
    const target = getRedirectTarget(document.location.href)
    if (target !== null) {
      document.location.href = target
    }
  }

  return {}
}

export default useRedirectToStandard
